import React, { useMemo } from 'react';
import { Col, DatePicker, Input, Radio, Select } from 'antd';
import moment from 'moment-timezone';
import { isEmpty } from 'lodash';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/tripsTaxiOverview.linkstate';
import { SearchOutlined } from '@ant-design/icons';
import { allRequestTaxiStatus } from '../../../shared/types';

const isNotEmpty = (s: string) => s && !isEmpty(s);

export const TripsFilter = () => {
    const [{ selectedDateRange, quickStatusFilter, search }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();

    const rangePickerValue = useMemo(() => {
        return isNotEmpty(selectedDateRange?.fromDate) && isNotEmpty(selectedDateRange?.toDate)
            ? [moment(selectedDateRange?.fromDate), moment(selectedDateRange?.toDate)]
            : [null, null];
    }, [selectedDateRange]);

    const handleRangePickerChanged = (dates: [any, any]) => {
        patchState({
            selectedDateRange:
                dates && dates[0] && dates[1]
                    ? {
                          fromDate: dates[0].format('YYYY-MM-DD'),
                          toDate: dates[1].format('YYYY-MM-DD'),
                      }
                    : undefined,
        });
    };
    return (
        <>
            <Col>
                <Select
                    value={quickStatusFilter}
                    style={{ width: 200 }}
                    onChange={(value) => patchState({ quickStatusFilter: value })}
                    options={[
                        {
                            label: 'All',
                            value: 'All',
                        },
                        ...allRequestTaxiStatus.map((v) => ({
                            label: v,
                            value: v,
                        })),
                    ]}
                />
            </Col>
            <Col style={{ width: 280 }}>
                <Input
                    value={search}
                    placeholder={'Search by Rider name'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
            <Col>
                <DatePicker.RangePicker value={rangePickerValue as any} onChange={handleRangePickerChanged} />
            </Col>
        </>
    );
};
